export default [
  {
    name: "purchaseOder",
    path: "/purchase/oder-list",
    component: () => import("@/views/purchase/purchaseOder.vue"),
    meta: {
      title: "营销礼品采购单列表",
    },
  },
  {
    name: "marketingGiftList",
    path: "/purchase/marketing-gift-list",
    component: () => import("@/views/purchase/marketingGiftList.vue"),
    meta: {
      title: "营销礼品清单",
    },
  },
  {
    name: "oderDetail",
    path: "/purchase/oder-detail",
    component: () => import("@/views/purchase/oderDetail.vue"),
    meta: {
      parentAuth: "/purchase/oder-list",
      title: "营销礼品采购单详情",
    },
  },
  {
    name: "supplierList",
    path: "/purchase/supplier-list",
    component: () => import("@/views/purchase/supplier.vue"),
    meta: {
      title: "供应商管理",
    },
  },
  {
    name: "supplierAdd",
    path: "/purchase/supplier-add",
    component: () => import("@/views/purchase/supplierAdd.vue"),
    meta: {
      title: "新增档案",
      parentAuth: "/purchase/supplier-list",
      notCache: true,
    },
  },
  {
    // 需求采购清单
    name: "SpecialPurchaseRequisition",
    path: "/purchase/special-procurement-list",
    component: () => import("@/views/purchase/speciaProcurement/list.vue"),
    meta: {
      title: "需求采购清单",
    },
  },
  {
    // 需求采购详情
    name: "SpecialPurchaseDetail",
    path: "/purchase/special-procurement-detail",
    component: () => import("@/views/oaJumpOder/specialDetail.vue"),
    meta: {
      parentAuth: "/purchase/oder-list",
      title: "需求采购详情",
    },
  },
  {
    name: "SpecialPurchaseEdit",
    path: "/purchase/special-procurement-edit",
    component: () => import("@/views/oaJumpOder/specialEdit.vue"),
    meta: {
      parentAuth: "/purchase/special-procurement-list",
      title: "专项采购",
    },
  },

  // -----------------------------------------------采购需求与管理项目路由-----------------------------------------------
  // ----------------------- 供应商管理 -----------------------
  // 采购分类
  {
    name: "supplierClassification",
    path: "/purchase/supplierManagement/classification",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/classification.vue"
      ),
    meta: {
      title: "采购分类",
    },
  },
  // 供应商准入申请
  {
    name: "supplierAllowApplicationsList",
    path: "/purchase/supplierManagement/allowApplications/list",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/allowApplications/list.vue"
      ),
    meta: {
      title: "供应商准入申请列表",
    },
  },
  {
    name: "supplierAllowApplicationsDetail",
    path: "/purchase/supplierManagement/allowApplications/detail",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/allowApplications/detail.vue"
      ),
    meta: {
      parentAuth: "/purchase/supplierManagement/allowApplications/list",
      title: "供应商准入",
    },
    props: (route) => ({ ...route.query }),
  },
  // 供应商调级申请
  {
    name: "supplierAdjustLevelApplicationsList",
    path: "/purchase/supplierManagement/adjustLevelApplications/list",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/adjustLevelApplications/list.vue"
      ),
    meta: {
      title: "供应商调级申请列表",
    },
  },
  {
    name: "supplierAdjustLevelApplicationsDetail",
    path: "/purchase/supplierManagement/adjustLevelApplications/detail",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/adjustLevelApplications/detail.vue"
      ),
    meta: {
      parentAuth: "/purchase/supplierManagement/adjustLevelApplications/list",
      title: "供应商调级",
    },
    props: (route) => ({ ...route.query }),
  },

  // 供应商淘汰申请
  {
    name: "supplierEliminateApplicationsList",
    path: "/purchase/supplierManagement/eliminateApplications/list",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/eliminateApplications/list.vue"
      ),
    meta: {
      title: "供应商淘汰申请列表",
    },
  },
  {
    name: "supplierEliminateApplicationsDetail",
    path: "/purchase/supplierManagement/eliminateApplications/detail",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/eliminateApplications/detail.vue"
      ),
    meta: {
      parentAuth: "/purchase/supplierManagement/eliminateApplications/list",
      title: "供应商淘汰",
    },
    props: (route) => ({ ...route.query }),
  },

  // 供应商档案
  {
    name: "supplierProfileList",
    path: "/purchase/supplierManagement/supplierProfile/list",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/supplierProfile/list.vue"
      ),
    meta: {
      title: "供应商档案列表",
    },
    props: (route) => ({ ...route.query }),
  },
  {
    name: "supplierProfileDetail",
    path: "/purchase/supplierManagement/supplierProfile/detail",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/supplierProfile/detail.vue"
      ),
    meta: {
      parentAuth: "/purchase/supplierManagement/supplierProfile/list",
      title: "供应商档案详情",
    },
    props: (route) => ({ ...route.query }),
  },
  {
    name: "supplierProfileAdd",
    path: "/purchase/supplierManagement/supplierProfile/add",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/supplierProfile/add.vue"
      ),
    meta: {
      parentAuth: "/purchase/supplierManagement/supplierProfile/list",
      title: "新增供应商",
    },
    props: (route) => ({ ...route.query }),
  },
  {
    name: "SupplierReserveList",
    path: "/purchase/supplierManagement/reserve/list",
    component: () =>
      import("@/views/purchaseManagement/supplierManagement/reserve/list.vue"),
    meta: {
      title: "供应商储备申请列表",
    },
  },
  {
    name: "SupplierReserveDetail",
    path: "/purchase/supplierManagement/reserve/detail",
    component: () =>
      import(
        "@/views/purchaseManagement/supplierManagement/allowApplications/detail.vue"
      ),
    meta: {
      parentAuth: "/purchase/supplierManagement/reserve/list",
      title: "供应商储备申请",
    },
    props: (route) => ({ ...route.query, formType: "reserve" }),
  },
  // ----------------------- 物料管理 -----------------------
  // 分组设置
  {
    name: "groupSettings",
    path: "/materialManagement/groupSettings",
    component: () =>
      import("@/views/purchaseManagement/materialManagement/groupSettings.vue"),
    meta: {
      title: "分组设置",
    },
  },
  // 单位管理
  {
    name: "unitManagement",
    path: "/materialManagement/unitManagement",
    component: () =>
      import(
        "@/views/purchaseManagement/materialManagement/unitManagement.vue"
      ),
    meta: {
      title: "单位管理",
    },
  },
  // 物料管理
  {
    name: "materialManagement",
    path: "/materialManagement/material",
    component: () =>
      import("@/views/purchaseManagement/materialManagement/material.vue"),
    meta: {
      title: "物料管理",
    },
  },
  // ----------------------- 待提交需求 -----------------------
  {
    name: "unSubmitLeadsList",
    path: "/unSubmitManagement/unSubmitLeadsList",
    component: () =>
      import("@/views/purchaseManagement/unSubmitManagement/unSubmitLeadsList.vue"),
    meta: {
      title: "待提交需求管理",
    },
  },
  // ----------------------- 采购工作台 -----------------------
  {
    name: "pruchaseWorkbench",
    path: "/purchase/pruchaseWorkbench",
    component: () =>
      import("@/views/purchaseManagement/pruchaseWorkbench/index.vue"),
    meta: {
      title: "采购工作台",
    },
  },
  // ----------------------- 采购需求 -----------------------
  {
    name: "purchaseLeadsList",
    path: "/purchase/pruchaseLeads",
    component: () =>
      import("@/views/purchaseManagement/purchaseLeads/purchaseLeadsList.vue"),
    meta: {
      title: "采购需求管理",
    },
  },
  {
    name: "purchaseReqDescMgmtList",
    path: "/purchase/purchaseReqDescMgmt",
    component: () =>
      import("@/views/purchaseManagement/purchaseReqDescMgmt/index.vue"),
    meta: {
      title: "采购需求管理（新）",
    },
  },
  {
    name: "purchaseReqDescMgmtDetail",
    path: "/purchase/purchaseReqDescMgmt/detail",
    component: () =>
      import("@/views/purchaseManagement/purchaseReqDescMgmt/detail.vue"),
    meta: {
      parentAuth: "/purchase/purchaseReqDescMgmt",
      title: "采购需求申请单详情",
    },
  },
  {
    name: "purchaseLeadsDetail",
    path: "/purchase/pruchaseLeads/detail",
    component: () =>
      import(
        "@/views/purchaseManagement/purchaseLeads/purchaseLeadsDetail.vue"
      ),
    meta: {
      parentAuth: "/purchase/pruchaseLeads",
      title: "采购需求申请单详情",
    },
  },
  // {
  //   name: 'purchaseLeadsDetailForSee',
  //   path: '/purchase/pruchaseLeadsForSee/detail',
  //   component: () =>
  //     import(
  //       '@/views/purchaseManagement/purchaseLeads/purchaseLeadsDetail.vue'
  //     ),
  //     meta: {
  //       parentAuth: '/purchase/pruchaseLeads',
  //       title: '采购需求申请单详情'
  //     }
  // },
  {
    name: "purchaseLeadsToSourcing",
    path: "/purchase/pruchaseLeads/purchaseLeadsToSourcing",
    component: () =>
      import(
        "@/views/purchaseManagement/purchaseLeads/purchaseLeadsToSourcing.vue"
      ),
    meta: {
      parentAuth: "/purchase/sourcingManagement/sourcingPriceConfirm",
      title: "需求转寻源",
    },
  },
  {
    name: "purchaseLeadsToOrder",
    path: "/purchase/pruchaseLeads/purchaseLeadsToOrder",
    component: () =>
      import(
        "@/views/purchaseManagement/purchaseLeads/purchaseLeadsToSourcing.vue"
      ),
    meta: {
      parentAuth: "/purchase/sourcingManagement/sourcingPriceConfirm",
      title: "需求转订单",
    },
  },
  // ----------------------- 寻源管理 -----------------------
  // 寻源核价列表
  {
    name: "sourcingPriceConfirm",
    path: "/purchase/sourcingManagement/sourcingPriceConfirm",
    component: () =>
      import(
        "@/views/purchaseManagement/sourcingManagement/sourcingPriceConfirmList.vue"
      ),
    meta: {
      title: "寻源核价列表",
    },
  },
  {
    name: "sourcingPriceConfirmDetailAdd",
    path: "/purchase/sourcingManagement/sourcingPriceConfirm/detail/add",
    component: () =>
      import("@/views/purchaseManagement/sourcingManagement/detail/index.vue"),
    meta: {
      parentAuth: "/purchase/sourcingManagement/sourcingPriceConfirm",
      title: "新增寻源核价",
    },
  },
  {
    name: "sourcingPriceConfirmDetailToSourcingAdd",
    path:
      "/purchase/sourcingManagement/sourcingPriceConfirm/detail/toSourcingAdd",
    component: () =>
      import(
        "@/views/purchaseManagement/sourcingManagement/detail/toSourceIndex.vue"
      ),
    meta: {
      parentAuth: "/purchase/sourcingManagement/sourcingPriceConfirm",
      title: "新增寻源核价",
    },
  },
  {
    name: "sourcingPriceConfirmDetailEdit",
    path: "/purchase/sourcingManagement/sourcingPriceConfirm/detail/edit",
    component: () =>
      import(
        "@/views/purchaseManagement/sourcingManagement/detail/editIndex.vue"
      ),
    meta: {
      parentAuth: "/purchase/sourcingManagement/sourcingPriceConfirm",
      title: "寻源核价详情",
    },
  },
  {
    name: "sourcingToOrder",
    path: "/purchase/pruchaseLeads/sourcingToOrder",
    component: () =>
      import(
        "@/views/purchaseManagement/sourcingManagement/sourcingToOrder.vue"
      ),
    meta: {
      parentAuth: "/purchase/sourcingManagement/sourcingPriceConfirm",
      title: "寻源转订单",
    },
  },
  // ----------------------- 描述型寻源核价 -----------------------
  {
    name: 'sourceDescMgmtList',
    path: '/purchase/sourceDescMgmt',
    component: () =>
      import('@/views/purchaseManagement/sourceDescMgmt/sourceDescList.vue'),
    meta: {
      title: '寻源核价列表（新）'
    }
  },
  {
    name: 'sourceDescMgmtDetailAdd',
    path: '/purchase/sourceDescMgmt/detail/add',
    component: () => import('@/views/purchaseManagement/sourceDescMgmt/detail/index.vue'),
    meta: {
      parentAuth: '/purchase/sourceDescMgmt',
      title: '新增描述型寻源'
    }
  },
  {
    name: 'sourceDescMgmtDetailEdit',
    path: '/purchase/sourceDescMgmt/detail/edit',
    component: () =>
      import('@/views/purchaseManagement/sourceDescMgmt/detail/editIndex.vue'),
    meta: {
      parentAuth: '/purchase/sourceDescMgmt',
      title: '描述型寻源详情'
    }
  },
  {
    name: 'sourceDescMgmtDetailView',
    path: '/purchase/sourceDescMgmt/detail/view',
    component: () => import('@/views/purchaseManagement/sourceDescMgmt/detail/view.vue'),
    meta: {
      parentAuth: '/purchase/sourceDescMgmt',
      title: '描述型寻源详情'
    }
  },
  // -------------------------采购验收--------------------------
  {
    name: "procurementAcceptanceList",
    path: "/purchase/procurementAcceptance/procurementAcceptanceRecordList",
    component: () =>
      import(
        "@/views/purchaseManagement/procurementAcceptance/procurementAcceptanceRecordList.vue"
      ),
    meta: {
      title: "采购验收记录",
    },
  },
  {
    name: "orderAcceptanceList",
    path: "/purchase/procurementAcceptance/orderAcceptanceList",
    component: () =>
      import(
        "@/views/purchaseManagement/procurementAcceptance/orderAcceptanceList.vue"
      ),
    meta: {
      parentAuth:
        "/purchase/procurementAcceptance/procurementAcceptanceRecordList",
      title: "订单验收明细",
    },
  },
  {
    name: "procurementAcceptanceDetail",
    path: "/purchase/procurementAcceptance/procurementAcceptanceRecordDetail",
    component: () =>
      import(
        "@/views/purchaseManagement/procurementAcceptance/procurementAcceptanceRecordDetail.vue"
      ),
    meta: {
      parentAuth:
        "/purchase/procurementAcceptance/procurementAcceptanceRecordList",
      title: (route) =>
        route.query?.isEditState == "true" ? "新建采购验收" : "采购验收详情",
    },
    props: (route) => ({
      ...route.query,
    }),
  },
  // ----------------------- 采购订单 -----------------------
  {
    name: "purchaseOrderList",
    path: "/purchase/purchaseOrder/purchaseOrderList",
    component: () =>
      import("@/views/purchaseManagement/purchaseOrder/purchaseOrderList.vue"),
    meta: {
      title: "采购订单列表",
    },
  },
  {
    name: "purchaseOrderForm",
    path: "/purchase/purchaseOrder/purchaseOrderForm",
    component: () =>
      import("@/views/purchaseManagement/purchaseOrder/purchaseOrderForm.vue"),
    meta: {
      parentAuth: "/purchase/purchaseOrder/purchaseOrderList",
      title: "采购订单详情-编辑",
    },
  },
  {
    name: "purchaseOrderDetail",
    path: "/purchase/purchaseOrder/purchaseOrderDetail",
    component: () =>
      import(
        "@/views/purchaseManagement/purchaseOrder/purchaseOrderDetail.vue"
      ),
    meta: {
      parentAuth: "/purchase/purchaseOrder/purchaseOrderList",
      title: "采购订单详情",
    },
  },
  // -------------------------报价成本记录--------------------------
  {
    name: "quotationCostRecord",
    path: "/purchase/quotationCostRecord",
    component: () =>
      import("@/views/purchaseManagement/quotationCostRecord/list.vue"),
    meta: {
      title: "报价成本记录",
    },
  },
  // -------------------------采购评价--------------------------
  {
    name: "purchaseEvaluateIndicatorLibrary",
    path: "/purchase/purchaseEvaluateIndicatorLibrary",
    component: () =>
      import("@/views/purchaseManagement/evaluate/IndicatorLibrary/index.vue"),
    meta: {
      title: "指标库",
    },
  },
  {
    name: 'purchaseEvaluatePlan',
    path: '/purchase/purchaseEvaluatePlan',
    component: () => import('@/views/purchaseManagement/evaluate/plan/index.vue'),
    meta: {
      title: '评价方案',
    },
  },
  {
    name: 'purchaseEvaluatePlanDetail',
    path: '/purchase/purchaseEvaluatePlanDetail',
    component: () => import('@/views/purchaseManagement/evaluate/plan/detail.vue'),
    meta: {
      parentAuth: '/purchase/purchaseEvaluatePlan',
      title: (route) => {
        switch (route.query.mode) {
          case 'add':
            return '新增评价方案'
          case 'edit':
            return '编辑评价方案'
          default:
            return '评价方案详情'
        }
      },
    },
    props: (route) => ({ ...route.query })
  },
  {
    name: 'purchaseEvaluateRecord',
    path: '/purchase/purchaseEvaluateRecord',
    component: () => import('@/views/purchaseManagement/evaluate/record/index.vue'),
    meta: {
      title: '评价记录',
    },
  },
  {
    name: 'purchaseEvaluateRecordDetail',
    path: '/purchase/purchaseEvaluateRecordDetail',
    component: () => import('@/views/purchaseManagement/evaluate/record/detail.vue'),
    meta: {
      parentAuth: '/purchase/purchaseEvaluateRecord',
      title: (route) => {
        switch (route.query.mode) {
          case 'add':
            return '新增评价记录'
          case 'edit':
            return '编辑评价记录'
          default:
            return '评价记录详情'
        }
      },
    },
    props: (route) => ({ ...route.query })
  },
  // -------------------------成本价格库--------------------------
  {
    name: "costPriceLibrary",
    path: "/purchase/costPriceLibrary",
    component: () =>
      import("@/views/purchaseManagement/costPriceLibrary/list.vue"),
    meta: {
      title: "成本价格库",
    },
  },
];
